<template>
  <div class="monitor container is-fluid">
    <div class="columns mt-0">
      <div class="column is-5">
        <h4 class="is-size-4-desktop">Monitor de pedidos por zona</h4>
        <h4 v-if="bodega" class="is-size-6-desktop">
          Sucursal: {{ bodega.sucursal.nombre }} - {{ bodega.nombre }}
        </h4>
        <div v-else class="notification is-info">
          El usuario identificado no se encuentra asignado a una sucursal y/o
          bodega. Favor contactar al administrador.
        </div>
      </div>
      <div class="column is-7">
        <filtros />
      </div>
    </div>
    <div v-if="zona.id > -1" class="columns">
      <div class="column is-12">
        <pedidos :items="pedidos" />
      </div>
    </div>
    <div v-else class="notification is-warning">
      Para ver los pedidos por zona, primero debe seleccionar una.
    </div>
  </div>
</template>

<script>
import * as signalR from '@microsoft/signalr'
import { mapGetters } from 'vuex'

import Filtros from '@/components/monitorZona/Filtros.vue'
import Pedidos from '@/components/monitorZona/Pedidos.vue'

const HUB_WEBSOCKET = 'pedidos-zona'
const UPDATE_EVENT = 'UpdatePedidosZona'

export default {
  name: 'Monitor',
  components: {
    Filtros,
    Pedidos
  },
  data() {
    return {
      connection: null,
      reconectando: false,
      isModalOpened: false,
      interval: null,
      intervalDelay: 50 * 60 * 1000
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    ...mapGetters('monitorZona', ['zona', 'pedidos'])
  },
  watch: {
    zona() {
      if (this.zona) {
        this.getPedidosZona()
        this.enableHub()
      } else {
        this.stopHub()
      }
    }
  },
  created() {
    const self = this
    this.createHub()
    this.interval = setInterval(() => {
      self.getPedidosZona()
    }, this.intervalDelay)
  },
  mounted() {
    if (this.zona) {
      this.getPedidosZona()
    }
  },
  beforeDestroy() {
    this.stopHub()
    clearInterval(this.interval)
  },
  methods: {
    async createHub() {
      const self = this
      const url = `${process.env.VUE_APP_BASE_URL}hubs/${HUB_WEBSOCKET}`
      if (this.connection) {
        await this.disableHub()
        await this.stopHub()
      }
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(url, {
          accessTokenFactory: () => localStorage.getItem('token') || ''
        })
        .withAutomaticReconnect([5000, 5000, 10000, 10000, 10000, 10000, 10000])
        .configureLogging(
          process.env.NODE_ENV === 'development'
            ? signalR.LogLevel.Information
            : signalR.LogLevel.Error
        )
        .build()
      this.connection.onreconnecting(() => (self.reconectando = true))
      this.connection.onreconnected(() => (self.reconectando = false))
      this.connection.onclose(() => {
        if (
          self.connection &&
          self.connection.state === 'Disconnected' &&
          self.reconectando
        ) {
          self.notificarError(
            'Se perdió la conexión con el servidor. Se volverá a intentar luego.'
          )
          setTimeout(() => {
            self.startHub()
          }, 30000)
        }
      })
      this.startHub().then((_) => this.enableHub())
    },
    startHub() {
      const self = this
      return this.connection
        .start()
        .then((_) => {
          self.connection
            .invoke('conectar-zona', `${self.zona.id}`)
            .catch((err) => {
              self.notificarError(err.toString())
            })
          self.$nextTick(() => self.getPedidosZona())
        })
        .catch((err) => {
          if (err.statusCode === 401) {
            if (!self.$store.getters['sesion/esValida']) {
              this.$router.push('/login').catch(() => {})
            } else {
              return self.$store.dispatch('sesion/refreshToken')
            }
          } else {
            self.procesarError(err)
          }
        })
    },
    async stopHub() {
      const self = this
      if (this.connection.state !== 'Disconnected')
        await this.connection
          .invoke('desconectar-zona', `${self.zona.id}`)
          .catch((err) => {
            self.notificarError(err.toString())
          })
          .then(async (_) => self.connection.stop())
    },
    async disableHub() {
      const self = this
      await self.connection.off(UPDATE_EVENT)
    },
    enableHub() {
      const self = this
      self.connection.on(UPDATE_EVENT, () =>
        self.$nextTick(() => self.getPedidosZona())
      )
    },
    getPedidosZona() {
      return this.$store
        .dispatch('monitorZona/updatePedidosZona')
        .catch((error) => this.procesarError(error))
    }
  }
}
</script>
